// extracted by mini-css-extract-plugin
export var body = "_f3-0";
export var sectionHeader = "_f3-4";
export var shortcutColumns = "_f3-2";
export var shortcutList = "_f3-1";
export var shortcutSection = "_f3-3";